import { MenuItem } from "./components/MenuItem";
import { GlobalCreateMenuDiv } from "./index.styles";

export const GlobalCreateMenu = ({ handleClose }) => {
  return (
    <GlobalCreateMenuDiv>
      <MenuItem handleClose={handleClose} />
    </GlobalCreateMenuDiv>
  );
};
